<template>
    <component :is="type" :class="['paragraph', variation, alignment]" @click="click">
        <slot/>
    </component>
</template>

<script>
export default {
    name: 'paragraph',
    props: {
        type: String,
        variation: String,
        alignment: String,
    },
    methods: {
        click() {
            this.$emit('click');
        },
    },
};
</script>

<style lang="scss">
@import 'global/default';

.paragraph {
    color: $color-neutral-dark-400;

    &.large {
        font-size: $font-size-body-lg;
        font-weight: $font-weight-body-lg;
        line-height: $line-height-body-lg;
    }
    &.medium {
        font-size: $font-size-body-default;
        font-weight: $font-weight-body-default;
        line-height: $line-height-body-default;
    }
    &.small {
        font-size: $font-size-body-xs;
        font-weight: $font-weight-body-xs;
        line-height: $line-height-body-xs;
    }
    &.label {
        font-size: $font-size-label;
        font-weight: $font-weight-label;
        line-height: $line-height-label;
    }
    &.button-medium {
        font-size: $font-size-button-default;
        font-weight: $font-weight-button-default;
        line-height: $line-height-button-default;
    }
    &.button-large {
        font-size: $font-size-button-lg;
        font-weight: $font-weight-button-lg;
        line-height: $line-height-button-lg;
    }
    &.code {
        font-family: "Anonymous Pro";
        font-size: $font-size-code;
        font-weight: $font-weight-code;
        line-height: $line-height-code;
    }

    &.center {
        text-align: center;
    }

}

</style>
